export default __webpack_public_path__ + "static/media/BIM_Libre_site_ADB_transparent.fe4e22a1.png";